import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ListenerService {
  private requisicoesPendente: BehaviorSubject<boolean>;
  private mensagemLoader: BehaviorSubject<string>;

  constructor() {
    this.requisicoesPendente = new BehaviorSubject(false);
    this.mensagemLoader = new BehaviorSubject("");
  }

  atualizarRequisicoesPendentes(pendente: boolean) {
    this.requisicoesPendente.next(pendente);
  }

  atualizarMensagemLoader(mensagem: string) {
    this.mensagemLoader.next(mensagem);
  }

  verificarRequisicoesPendentes(): Observable<boolean> {
    return this.requisicoesPendente.asObservable();
  }

  verificarMensagemLoader(): Observable<string> {
    return this.mensagemLoader.asObservable();
  }
}
